<template>
  <div class="CollectionContent ">
    <video class="video2" autoplay loop muted playsinline>
      <source  :src="video_src3" type="video/mp4" key="2">
    </video>
    <!-- <div class="bg_filter v2_filter"></div> -->
   
      <div class="content-header">
        <h1>SPOTS</h1>
        <!-- <div class="select-menu">
          <ul>
            <li>
              <input type="radio" name="selectMenu" value="menu1" checked id="radio01" />
              <label for="radio01" class="select-menu-label">menu1</label>
            </li>
            <li>
              <input type="radio" name="selectMenu" value="menu1" checked id="radio02" />
              <label for="radio02" class="select-menu-label">menu2</label>
            </li>
            <li>
              <input type="radio" name="selectMenu" value="menu1" checked id="radio03" />
              <label for="radio03" class="select-menu-label">menu3</label>
            </li>
          </ul>
        </div> -->
      </div>
      <div class="grid-wrapper">
       
        <!-- <div class="item item1 item-card" v-for="(img, index ) in items" v-bind:key="index" >
            <img class="item-img" v-lazy="img.path" v-if="img.isUse">
        </div> -->
        <!-- <div class="grid-items" v-for="(img, index ) in items" v-bind:key="index">
          <div v-if="img.isUse" class="item" :style="{'background-image': 'url(' + img.path + ')' , 'background-size':'cover', 'background-position':'center'}">
            
          </div>
          <div v-if="!img.isUse" class="item item-card" >
            <div class="bg_filter v2_filter"></div>
           <p>{{img.title}}</p>
           <h3>{{img.discription}}</h3>
           <p><span>{{img.pref}}</span><span>{{img.place}}</span></p>
          </div>
        </div> -->
      
          <div class="item item1 item-card item-flex-center">
            <h1>Marunouchi</h1>
            <p>Famous Sightseeing Spots </p>
            <p>In Tokyo</p>
          </div>
          <div class="item item2 " :style="{'background-image': 'url(' + imgurl_tokyoStation1 + ')' , 'background-size':'cover'}">2</div>
          <div class="item item3" :style="{'background-image': 'url(' + imgurl_shinmarunouchiBiru + ')' , 'background-size':'cover'}">3</div>
          <div class="item item4" :style="{'background-image': 'url(' + imgurl_shinmarunouchiBiruGarden + ')' , 'background-size':'cover'}">4</div>
          <div class="item item5" :style="{'background-image': 'url(' + imgurl_tokyoStation + ')' , 'background-size':'cover'}">5</div>
         
          <div class="item item6" :style="{'background-image': 'url(' + imgurl_tokyoStationWide3 + ')', 'background-size':'cover', 'background-position':'bottom'}">6</div>
         
          <div class="item item7 item-card item-flex-center">
            <h1>Odaiba</h1>
            <p>Famous Sightseeing Spots </p>
            <p>In Tokyo</p>
          </div>
          <div class="item item8" :style="{'background-image': 'url(' + imgurl_rainbouBrige1 + ')' , 'background-size':'cover', 'background-position':'bottom'}">8</div>
          <div class="item item9" :style="{'background-image': 'url(' + imgurl_rainbouBrige8 + ')' , 'background-size':'cover','background-position':'left bottom'}">9</div>
          
          <div class="item item10" :style="{'background-image': 'url(' + imgurl_rainbouBrige4 + ')' , 'background-size':'cover'}">10</div>
          <div class="item item11" :style="{'background-image': 'url(' + imgurl_rainbouBrige6 + ')' , 'background-size':'cover','background-position':'left bottom'}">11</div>
         
          <div class="item item12" :style="{'background-image': 'url(' + imgurl_rainbouBrige7 + ')' , 'background-size':'cover'}">12</div>
          <div class="item item13" :style="{'background-image': 'url(' + imgurl_rainbouBrige4 + ')' , 'background-size':'cover'}">13</div>
       
         


      
    </div>
    <div class="content-footer">
      <div class="footer-menu">
        <router-link to="/">
        <h3>HOME</h3>
        <p>2018 TOKYO PHOTO TURE</p>
        <p>NOV. 13 - 16</p>
        </router-link>
      </div>
      <div class="footer-menu">
        <router-link to="/project">
        <h3>DATE</h3>
        <p>Photographer Travel In Tokyo</p>
          </router-link>
      </div>
      <div class="footer-menu">
          <router-link to="/collection">
        <h3>SPOTS</h3>
        <p>Famous Sightseeing Spots In Tokyo</p>
        </router-link>
      </div>
    </div>
    <!-- <div class="sns-footer">
        <div class="sns-item">Facebook</div>
        <div class="sns-item">Twitter</div>
        <div class="sns-item">Instagram</div>
      </div> -->
  </div>
</template>

<script>
export default {
  name: 'collectionContent',
  props: {
    msg: String
  },
  data() {
    return {
      video_src1: require("../assets/img/Indian Tea.mp4"),
      video_src2: require("../assets/img/Painting960.mp4"), 
      video_src3: require("../assets/img/Night-Traffic.mp4"),
      isTitle: true,
      // img: "../assets/img/tokyo/img1482b.jpg",
      // imgurl_hibiyaHiruzu: require("../assets/img/tokyo/img1368.jpg"),
      // imgurl_tokyoStation: require("../assets/img/tokyo/img1482b.jpg"),
      // imgurl_tokyoStation1: require("../assets/img/tokyo/img1578.jpg"),
      // imgurl_tokyoStation2: require("../assets/img/tokyo/img1617.jpg"),
      // imgurl_tokyoStation3: require("../assets/img/tokyo/img1635_1x1.jpg"),
      // imgurl_tokyoStation4: require("../assets/img/tokyo/img1674a.jpg"),
      // imgurl_tokyoStation5Kittei: require("../assets/img/tokyo/img1701.jpg"),
      // imgurl_shinmarunouchiBiruGarden: require("../assets/img/tokyo/img1692.jpg"),
      // imgurl_tokyoStationWide: require("../assets/img/tokyo/img1551b.jpg"),
      // imgurl_tokyoStationWide2: require("../assets/img/tokyo/img1551.jpg"),
      // imgurl_tokyoStationWide3: require("../assets/img/tokyo/img1674trim3.jpg"),
      // imgurl_shinmarunouchiBiru: require("../assets/img/tokyo/img1559.jpg"),

     
      // imgurl_yuurakucyouGard: require("../assets/img/tokyo/img1723.jpg"),
      // imgurl_hibiyaHills: require("../assets/img/tokyo/img1368.jpg"),
      // imgurl_hibiyaHills2: require("../assets/img/tokyo/img1747.jpg"),
      
      
      // imgurl_tokyotower4gou: require("../assets/img/tokyo/img5325.jpg"),
      
      // imgurl_rainbouBrige1: require("../assets/img/tokyo/img3908.jpg"),
      // imgurl_rainbouBrige2: require("../assets/img/tokyo/img3933.jpg"),
      // imgurl_rainbouBrige3: require("../assets/img/tokyo/img4077a.jpg"),
      // imgurl_rainbouBrige4: require("../assets/img/tokyo/img4086.jpg"),
      // imgurl_rainbouBrige5: require("../assets/img/tokyo/img4037.jpg"),
      // imgurl_rainbouBrige6: require("../assets/img/tokyo/img3983.jpg"),
      // imgurl_rainbouBrige7: require("../assets/img/tokyo/img4013.jpg"),
      // imgurl_rainbouBrige8: require("../assets/img/tokyo/img4037_572x800.jpg"),
      // imgurl_rainbouBrige9: require("../assets/img/tokyo/img4044_572x800.jpg"),
      

      // imgurl_hanadaJal: require("../assets/img/tokyo/img6377.jpg"),
      // imgs: [ 
      // {imgurl:"../assets/img/tokyo/img1482b.jpg"},
      // {imgurl:"../assets/img/tokyo/img1551b.jpg"},
      // ],
      // imgs: [ 
      // {imgurl: require("../assets/img/tokyo/img1482b.jpg")},
      // {imgurl: require("../assets/img/tokyo/img1551b.jpg")},
      // ],
      // imgs: [
      //   { no:1, imgurl: require("../assets/img/tokyo/img1482b.jpg"), pref:'東京', place:'丸の内',  discription:'行幸通り', link:'' },
      //   { no:2, imgurl: require("../assets/img/tokyo/img1551b.jpg"), pref:'東京', place:'Ako',  discription:'丸の内中央広場', link:''  },
      //   { no:3, imgurl: require("../assets/img/tokyo/1629a.jpg"), pref:'東京', place:'Ako',  discription:'丸の内北口', link:''  },
      //   { no:4, imgurl: require("../assets/img/tokyo/img1674trima.jpg"), pref:'東京', place:'Umeda',  discription:'新丸ビル7階テラス', link:''  },
      //   { no:5, imgurl: require("../assets/img/tokyo/img1635_1x1.jpg"), pref:'東京', place:'Umeda',  discription:'新丸ビル7階テラス', link:''  },
      //   { no:6, imgurl: require("../assets/img/tokyo/img4037_572x800.jpg"), pref:'東京', place:'お台場',  discription:'台場メモリアルツリー', link:''  },
      //   { no:7, imgurl: require("../assets/img/tokyo/img4044_572x800.jpg"), pref:'東京', place:'お台場',  discription:'お台場屋形船', link:''  },
      //   { no:8, imgurl: require("../assets/img/tokyo/img5325_914x1280.jpg"), pref:'東京', place:'芝公園',  discription:'芝公園4号', link:'' },
      //   { no:9, imgurl: require("../assets/img/tokyo/img5450_1280.jpg"), pref:'東京', place:'芝公園',  discription:'東京タワー駐車場', link:'' },
      //   { no:10, imgurl: require("../assets/img/tokyo/img0748.jpg"), pref:'東京', place:'丸の内',  discription:'丸ビルクリスマスツリー', link:'' },
      // ],
    //   items: [
    //   {no:1, path: 'https://dummyimage.com/600x600/fcc/000.png&text=Uploaded1'},
    //   {no:2, path: 'https://dummyimage.com/600x600/fcc/000.png&text=Uploaded2'},
    //   {no:3, path: 'https://dummyimage.com/600x600/fcc/000.png&text=Uploaded3'},
    //   {no:4, path: 'https://dummyimage.com/600x600/fcc/000.png&text=Uploaded4'},
    // ] 
    //   items: [
    //   {no:1, path: require('../assets/img/tokyo/img1482b.jpg'), isUse:false, pref:'東京', place:'丸の内',  discription:'東京駅周辺を撮る',  title:'DAY-1',  link:''},
    //   {no:2, path: require('../assets/img/tokyo/img1482b.jpg'), isUse:true, pref:'東京', place:'丸の内',  discription:'行幸通り',  title:'東京駅舎',  link:''},
    //   {no:3, path: require('../assets/img/tokyo/img1551b.jpg'), isUse:true, pref:'東京', place:'Ako',  discription:'丸の内中央広場',  title:'東京駅舎',  link:''},
    //   {no:4, path: require('../assets/img/tokyo/img1629a.jpg'), isUse:true, pref:'東京', place:'Ako',  discription:'丸の内北口',  title:'東京駅舎',  link:''},
    //   {no:5, path: require('../assets/img/tokyo/img1674trima.jpg'), isUse:true, pref:'東京', place:'Umeda',  discription:'新丸ビル7階テラス1',  title:'東京駅舎',  link:''},
    //   {no:6, path: require('../assets/img/tokyo/img1635_1x1.jpg'), isUse:true, pref:'東京', place:'Umeda',  discription:'新丸ビル7階テラス2',  title:'東京駅舎',  link:''},
    //   {no:7, path: require('../assets/img/tokyo/img1674trima.jpg'), isUse:false,  pref:'東京', place:'お台場',  discription:'お台場周辺を撮る',  title:'DAY-2',  link:''},
    //   {no:8, path: require('../assets/img/tokyo/img4037_572x800.jpg'), isUse:true, pref:'東京', place:'お台場',  discription:'台場メモリアルツリー',  title:'レインボーブリッジ',  link:''},
    //   {no:9, path: require('../assets/img/tokyo/img4044_572x800.jpg'), isUse:true, pref:'東京', place:'お台場',  discription:'お台場屋形船',  title:'レインボーブリッジ',  link:''},
    //   {no:10, path: require('../assets/img/tokyo/img1674trima.jpg'), isUse:false, pref:'東京', place:'汐留',  discription:' 汐留場周辺を撮る',  title:'DAY-3',  link:''},
    //   {no:11, path: require('../assets/img/tokyo/img5325_914x1280.jpg'), isUse:true, pref:'東京', place:'芝公園',  discription:'芝公園4号',  title:'東京タワー',  link:''},
    //   {no:12, path: require('../assets/img/tokyo/img5450_1280.jpg'), isUse:true, pref:'東京', place:'芝公園',  discription:'東京タワー駐車場',  title:'東京タワー',  link:''}
    // ] 
    }
  },
  // created() {
  // },
  // mounted: function(){

      // window.addEventListener("DOMContentLoaded", this.handleLoad);
        // this.loading = true;
        // this.getUnits()
  // },
  // methods: {
    // handleLoad() {
    //    console.log("All resources finished loading!");
    // }
    // getUnits: function() {
      // console.log("getUnits!");
      // setTimeout(() => {
      //   this.loading = false;
      // }, 1500);
    // },
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//  @import "../assets/scss/page/CollectionComponent.scss";
.CollectionContent{
  width: 100%;
  height: 100%;
  text-align: center;
  padding: auto 0;
}
.load-containt{
  // margin-top: -6rem;
  width: 100vw;
  height: 100vh;
  display: flex;
  // justify-content: center;
  // align-items: center;
  // border: 1px solid red;
  background-color: #9b2727;
  z-index: 1000;
}
.title{
  width: 20rem;
  height: 3rem;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  margin: auto;
  // border: 1px solid white;
}

//header
.content-header{
  position: relative;
  width: 100%;
  height: 20rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-header .select-menu{
  position: absolute;
  top: 10rem;
  left: 0;
}
.content-header .select-menu ul{
  margin: 1rem;
}
.content-header .select-menu .select-menu-label{
  font-size: .6rem;
  margin: 0 .5rem;
  vertical-align: bottom;
}

.content-footer{
  position: relative;
  width: 100vw;
  height: 20rem;
  display: flex;
  justify-content: space-around;
}
.footer-menu{
  width: 25%;
  padding: 1rem;
  text-align: left;
}
.sns-footer{
  position: relative;
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sns-item{
  width: 5rem;
  margin: 0 1rem;
}
//gulid
.grid-wrapper{
  position: relative;
  // padding: 2rem;
  margin: 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  grid-template-columns: repeat(2, 1fr)  ;
  margin: 0px;
  // border: 1px solid yellow;
  @media (min-width:500px) {
   display: grid;
   grid-gap: 2px;
   grid-template-columns: repeat(2, 1fr) ;
  }
  @media (min-width:768px) {
   display: grid;
   grid-template-columns: repeat(4, 1fr) ;
  }
  @media (min-width:1200px) {
   display: grid;
   grid-template-columns: repeat(6, 1fr) ;
  }
}
.grid-wrapper > div {
  // border: 1px solid rgba(0,0,0,.4);
}
.item{
  overflow:hidden;
  text-align: left;
  grid-column: span 2;
  min-height: 33vh;
  background-position: center;
  @media (min-width:500px) {
   min-height: 55vh;
  }
   @media (min-width:768px) {
   min-height: 55vh;
  }
   @media (min-width:1200px) {
   min-height: 55vh;
  }
   @media (min-width:2560px) {
   min-height: 55vh;
  }
}
.item-img{
  width: 100%;
  height: auto;
}
.item-card{
  padding: .5rem 1rem;
  border: 1px solid rgba(250,250,250,.2);
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.8);
}
.item-left{
  text-align: left;
}
.item-center{
  text-align: center;
}
.item-right{
  text-align: right;
}
.item-flex-center{
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}


.item3{
  @media (min-width:500px) {
    width: 100%;
    grid-column: span 2;
    grid-row: span 2;
  }
}
.item6{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 1;
    background-position: bottom 100px;
  }
   @media (min-width:1200px) {
    grid-column: span 6;
    grid-row: span 1;
    background-position: bottom 100px;
  }
}
.item7{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 1;
    background-position: bottom 100px;
  }
   @media (min-width:1200px) {
    grid-column: span 2;
    grid-row: span 1;
    background-position: bottom 100px;
  }
}
.item8{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 1;
    background-position: bottom 100px;
  }
   @media (min-width:1200px) {
    grid-column: span 4;
    grid-row: span 1;
    background-position: bottom 100px;
  }
}
.item9{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 2;
    grid-row: span 3;
    background-position: bottom 100px;
  }
   @media (min-width:1200px) {
    grid-column: span 4;
    grid-row: span 3;
    background-position: bottom 100px;
  }
}

.item13{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 1;
    background-position: bottom 100px;
  }
   @media (min-width:1200px) {
    grid-column: span 6;
    grid-row: span 2;
    background-position: bottom 100px;
  }
}


video.video2, video.video3 {
  position: fixed;
  top: 0%;
  left: 0%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  display: block;
}

.bg_filter{
    background-color: rgba(0,0,0,.3);
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -1;
}



</style>
